import { io } from "socket.io-client";

const socket = io("http://localhost:3000");

export const initNfcService = (callbacks = {}) => {
  socket.off("connect");
  socket.off("disconnect");
  socket.off("nfc-uid");
  socket.off("nfc-read-status");
  socket.off("nfc-write-status");
  socket.off("nfc-fast-write-status");

  socket.on("connect", () => {
    if (callbacks.onConnect) callbacks.onConnect();
  });

  socket.on("disconnect", () => {
    if (callbacks.onDisconnect) callbacks.onDisconnect();
  });

  socket.on("nfc-uid", (data) => {
    if (callbacks.onNfcUid) callbacks.onNfcUid(data);
  });

  socket.on("nfc-read-status", (res) => {
    if (callbacks.onReadStatus) callbacks.onReadStatus(res);
  });

  socket.on("nfc-write-status", (res) => {
    if (callbacks.onWriteStatus) callbacks.onWriteStatus(res);
  });

  socket.on("nfc-fast-write-status", (res) => {
    if (callbacks.onWriteStatus) callbacks.onWriteStatus(res);
  });

  return socket;
};

export const nfcActions = {
  read: () => socket.emit("nfc-read"),
  checkHealth: () => socket.emit("nfc-heard_check"),
};
